
    import './styles.scoped.css';
    export default {
  "custom-content": "awsui_custom-content_1oq04_rbts3_5"
};
  